module.exports = __webpack_public_path__ + "static/media/larry2.88660d0c.mp3";